export default __webpack_public_path__ + "static/media/droneMillInventory.fc2d5640.pdf";